export const en =
  {
    "Try Anyplay": "Try Anyplay",
    "Title": "Title",
    "Author": "Author(s)",
    'Publisher': 'Publisher',
    'Narrator': 'Narrator',
    'Language': 'Language',
    'Date': 'Date',
    'Playtime': 'Playtime',
    'Publisher description': 'Publisher\'s description',
    'Join Anyplay': ' Join Anyplay!',
    'Anytime': 'Anytime.',
    'Anywhere': 'Anywhere.',
    'For Anyone': 'For Anyone.',
    'We bring the best audio storytelling to every corner of the world': 'We bring the best audio storytelling to every corner of the world..',
    'Sign Up': 'Sign Up',
    'Sign In': 'Sign In',
    'Not found': 'Not found',
    'Preview': 'Preview'
}
